module.exports = __webpack_public_path__ + "img/lb.bad5b6cd.svg";